import React, { useEffect, useRef, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { BsCaretLeft, BsCaretRight } from "react-icons/bs";
import { FaLongArrowAltLeft } from "react-icons/fa";
import ReactPlayer from "react-player";
import { Tooltip } from "..";

type ZoomImageUploadProps = {
  image: any[];
  setShowAllImages: (value: React.SetStateAction<number | null>) => void;
  currentIndex: number;
  handlePrev: () => void;
  handleNext: () => void;
  totalImages: number;
  selectedVideos: any[];
  imageUpload: any[];
  removeMedia?: (indexToRemove: number) => void;
  removeMediaItem?: (indexToRemove: number) => void;
};
const ZoomImageUpload: React.FC<ZoomImageUploadProps> = ({
  image,
  currentIndex,
  setShowAllImages,
  handlePrev,
  handleNext,
  totalImages,
  imageUpload,
  removeMedia,
  removeMediaItem,
}) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setShowAllImages(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setShowAllImages]);

  // const isBlobUrl = (url: string | undefined) => url && (url.startsWith("blob:") || url?.startsWith("image/jpeg"));
  // const isBlobUrl = (url: string | undefined) => {
  //   if (!url) return false;
  //   return url.startsWith("data:image/jpeg;");
  // };
  const isVideoBlobUrl = (url: string | undefined) =>
    url?.startsWith("blob:") && !url.startsWith("data:image/jpeg;");

  const [playing, setPlaying] = useState(false);
  const playerRef = useRef(null); // Create a ref using useRef
  const play = () => setPlaying(true);
  const pause = () => setPlaying(false);

  return (
    <div
      className="picModal backdrop-filter backdrop-blur-[10px] bg-black/20 fixed inset-40 w-3/5 mx-auto py-10 z-30 justify-center overflow-y-hidden items-center flex"
      ref={containerRef}
    >
      <div className="p-4 flex items-center justify-center relative w-[50%] h-[95%]">
        {isVideoBlobUrl(image[currentIndex]) ? (
          <div className="flex relative w-full h-full">
            <ReactPlayer
              ref={playerRef}
              // key={index}
              url={image[currentIndex]}
              width="100%"
              height="100%"
              controls={true}
              playing={playing}
              onPlay={play}
              onPause={pause}
              volume={1}
              // muted={true}
              light
            />
            <div className="flex fixed top-[70px] right-[190px] ">
              <div className="flex items-center text-white cursor-pointer ">
                <Tooltip tooltip="remove video">
                  <AiOutlineClose
                    size={33}
                    onClick={() => {
                      if (removeMediaItem) removeMediaItem(currentIndex);
                    }}
                  />
                </Tooltip>
              </div>
            </div>
          </div>
        ) : (
          imageUpload.includes(image[currentIndex]) && (
            <div className="relative flex w-full h-full">
              <img
                src={image[currentIndex]}
                alt=""
                className="object-center object-cover w-full h-full"
              />
              <div className="flex fixed top-[70px] right-[190px]">
                <div className="flex items-center text-white cursor-pointer ">
                  <Tooltip tooltip="remove image">
                    <AiOutlineClose
                      size={33}
                      onClick={() => {
                        if (removeMedia) removeMedia(currentIndex);
                      }}
                    />
                  </Tooltip>
                </div>
              </div>
            </div>
          )
        )}
      </div>
      <div className="flex gap-3 fixed top-1 left-3 items-center justify-center">
        <button className="cursor-pointer h-10 w-10 items-center justify-center flex rounded-full">
          <Tooltip tooltip="back">
            <FaLongArrowAltLeft
              size={33}
              className="cursor-pointer text-white"
              onClick={() => setShowAllImages(null)}
            />
          </Tooltip>
        </button>
      </div>
      {/* <div className="flex fixed top-1 right-10">
        <div className="flex items-center text-white cursor-pointer ">
          <Tooltip tooltip="remove image">
            <AiOutlineClose
              size={33}
              onClick={() => {
                if (removeMedia) removeMedia(currentIndex);
                if (removeMediaItem) removeMediaItem(currentIndex);
              }}
            />
          </Tooltip>
        </div>
      </div> */}

      {image.length > 1 && (
        <>
          <button
            onClick={handlePrev}
            disabled={currentIndex === 0}
            className="fixed top-[50%] cursor-pointer left-44 h-10 w-10 items-center justify-center bg-white flex rounded-full disabled:bg-CoolGrey"
          >
            <BsCaretLeft size={35} className="cursor-pointer" />
          </button>
          <button
            onClick={handleNext}
            disabled={currentIndex === totalImages - 1}
            className="fixed top-[50%]  cursor-pointer right-44 h-10 w-10 items-center justify-center bg-white flex rounded-full disabled:bg-CoolGrey "
          >
            <BsCaretRight size={35} className="cursor-pointer" />
          </button>
        </>
      )}
    </div>
  );
};

export default ZoomImageUpload;
